import Promise from 'promise-polyfill'

export default function reject(data) {
    return Promise.reject(Object.assign(new Error, data))
}